<template>
    <div class="o-timeline" v-if="highlights_data.length > 1">
        <div class="o-timeline__container">
            <span class="o-timeline__separator"></span>
            <div class="o-timeline__item" v-bind:class="{'o-timeline__item--last': (index + 1) >= highlights_data.length}" v-for="(highlight, index) in highlights_data" :key="index">
                <button class="o-timeline__btn" v-bind:class="{'o-timeline__btn--active': $route.name == highlight.name }" v-on:click="goToHighlight( highlight.name )">{{ highlight.path }}</button>
                <span v-if="(index + 1) < highlights_data.length" class="o-timeline__separator"></span>
            </div>
            <span class="o-timeline__separator"></span>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {

        }
    }
}
</script>
